import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propArrayShape, propBool, propFunc, propNumber, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import SlideViewerLeftComponentImage from './SlideViewerLeftComponentImage';
const SlideViewerLeftComponentImages = (props) => {
    const { boxRef, canCheck, className, imageIndex, images, imagesRef, onChangeSelectSlide, onClickImage, selectMap, unit, } = props;
    const setRef = useCallback((el) => {
        if (!el) {
            return;
        }
        imagesRef.current[el.dataset.index] = el;
    }, [imagesRef]);
    return (_jsx("div", Object.assign({ className: `slide_viewer_left_images ${className}`, ref: boxRef }, { children: images.map((image, index) => (_jsx(SlideViewerLeftComponentImage, { canCheck: canCheck, checked: !!(selectMap === null || selectMap === void 0 ? void 0 : selectMap[image.id]), imageIndex: imageIndex, index: index, onChangeSelectSlide: onChangeSelectSlide, onClickImage: onClickImage, page: image, setRef: setRef, unit: unit }, image.id))) })));
};
SlideViewerLeftComponentImages.propTypes = {
    boxRef: propShape().isRequired,
    canCheck: propBool(),
    className: propStr().isRequired,
    imageIndex: propNumber().isRequired,
    images: propArrayShape().isRequired,
    imagesRef: propShape().isRequired,
    onChangeSelectSlide: propFunc(),
    onClickImage: propFunc().isRequired,
    selectMap: propShape(),
    unit: propShape(),
};
SlideViewerLeftComponentImages.defaultProps = {
    canCheck: false,
    onChangeSelectSlide: () => { },
    selectMap: null,
    unit: null,
};
export default SlideViewerLeftComponentImages;
